<script>
    import R, {LOADER} from "../lib/requests";
    import user from "../stores/user";
    import {router} from "../lib/Router/Router.svelte";
    import {formatDate} from "../lib/lib";
    import Warning from "../components/pages/Warning.svelte";

    const statuses = [
        '',
        'Νέα παραγγελία',
        'Σε εξέλιξη',
        'Απεσταλμένη',
        'Ολοκληρώθηκε',
        'Επιστράφηκε',
        'Ακυρώθηκε',
        'Απέτυχε η πληρωμή'
    ];

    let orders = null;

    const load = () => {
        const onSuccess = result => {
            orders = result;
        }

        const onFailure = err => {

        };

        R.handle(R.order.index, [], onSuccess, onFailure, LOADER.POPUP);
    }

    const openOrder = order => {
        router.go('/order/' + order.hash)();
    }

    load();

    $: if ($user.token && !orders) {
        load();
    }
</script>
<div class="container">
    {#if $user.token}
        <div class="mb-5">
            <h1>Οι Παραγγελίες μου</h1>
            <div class="heading-separator"></div>
        </div>
        {#if orders}
            {#if orders.length}
                <div class="row">
                    <div class="col-xl-8 col-lg-12 col-md-12">
                        <table class="table table-list">
                            <thead>
                            <tr>
                                <th>Αρ. Παραγγελίας</th>
                                <th class="text-end hidden-sm hidden-xs">Προϊόντα</th>
                                <th class="text-end hidden-sm hidden-xs">Τιμή</th>
                                <th class="hidden-sm hidden-xs">Κατάσταση</th>
                                <th>Ημερομηνία</th>
                            </tr>
                            </thead>
                            <tbody>
                            {#each orders as item}
                                <tr class="row-hover">
                                    <td>
                                <span class="is-link" on:click={ () => openOrder(item) }>
                                    { item.ref_id }
                                </span>
                                    </td>
                                    <td class="text-gray text-end hidden-sm hidden-xs">{ item.total_products }</td>
                                    <td class="text-gray text-end hidden-sm hidden-xs">{ item.total_price } €</td>
                                    <td class="text-gray hidden-sm hidden-xs">{ statuses[item.status_id] }</td>
                                    <td class="text-gray">{ formatDate(item.created_at, 'd-m-y H:i') }</td>
                                </tr>
                            {/each}
                            </tbody>
                        </table>
                    </div>
                </div>
            {:else}
                <p>
                    Προς το παρών δεν έχετε παραγγελίες.
                </p>
            {/if}
        {/if}
    {:else}
        <Warning warning="no-user" page="order-details" header="Σύνδεση στον λογαριασμό σας"/>
    {/if}
</div>